<template>
  <div class="grey lighten-5">
    <v-container v-if="loading">
      <v-skeleton-loader
        type="image"
        tile
        height="72"
        class="mb-4"
      />
      <v-card
        elevation="0"
        tile
        outlined
      >
        <v-container class="pt-0">
          <v-row>
            <v-col
              cols="9"
              class="py-0"
            >
              <v-skeleton-loader
                type="table-thead"
                tile
              />
              <v-divider />
              <v-skeleton-loader
                type="table-tbody"
                tile
              />
            </v-col>
            <v-divider
              vertical
              style="margin-right:-1px"
            />
            <v-col cols="3">
              <v-skeleton-loader
                type="heading"
                tile
                class="mt-1 mb-4"
              />
              <v-divider />
              <v-skeleton-loader
                type="text"
                tile
                class="mt-1 mb-4"
              />
              <v-skeleton-loader
                type="button"
                tile
                class="fill-width mb-2"
              />
              <v-skeleton-loader
                type="button"
                tile
                class="fill-width mb-2"
              />
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
    <v-container
      v-else-if="cartList.data.length"
      :class="$store.state.mobile ? 'px-0' : ''"
    >
      <div
        v-if="$store.state.mobile"
        class="pb-4 px-4 text-h5 font-medium"
      >
        <template v-if="$store.getters.languageGetter === '1'">
          عربة التسوق
        </template>
        <template v-else>
          Shopping Cart
        </template>
      </div>
      <v-card
        elevation="0"
        tile
        outlined
        class="mb-4"
      >
        <v-stepper
          :alt-labels="$store.state.mobile"
          :vertical="$store.state.mobile"
        >
          <v-stepper-header>
            <v-stepper-step step="1">
              <template v-if="$store.getters.languageGetter === '1'">
                التسوق
              </template>
              <template v-else>
                Shopping
              </template>
            </v-stepper-step>
            <v-divider />
            <v-stepper-step step="2">
              <template v-if="$store.getters.languageGetter === '1'">
                مكان الامر
              </template>
              <template v-else>
                Place order
              </template>
            </v-stepper-step>
            <v-divider />
            <v-stepper-step step="3">
              <template v-if="$store.getters.languageGetter === '1'">
                مكتمل
              </template>
              <template v-else>
                Completed
              </template>
            </v-stepper-step>
          </v-stepper-header>
        </v-stepper>
      </v-card>
      <v-card
        v-if="$store.state.mobile"
        elevation="0"
        tile
        outlined
      >
        <div
          v-for="(item, i) in cartList.data"
          :key="item.goodDetailId"
        >
          <v-container>
            <v-row>
              <v-col
                cols="auto"
                class="pe-0"
              >
                <v-checkbox
                  v-model="selected"
                  class="mt-0"
                  on-icon="mdi-check-circle"
                  off-icon="mdi-checkbox-blank-circle-outline"
                  :value="item"
                />
              </v-col>
              <v-col
                cols="4"
              >
                <router-link :to="{name: 'GoodsDetail', params: {id: item.goodId}}">
                  <v-img
                    :src="item.image + '?x-oss-process=image/resize,m_mfit,w_375,h_375'"
                    aspect-ratio="1"
                    contain
                    class="grey lighten-5"
                  >
                    <template v-slot:placeholder>
                      <v-row
                        class="fill-height ma-0"
                        align="center"
                        justify="center"
                      >
                        <v-progress-circular
                          indeterminate
                          color="grey"
                        />
                      </v-row>
                    </template>
                  </v-img>
                </router-link>
                <v-btn
                  class="mt-4"
                  depressed
                  outlined
                  text
                  @click="dialogDelete = true;toDelete = item.goodDetailId"
                >
                  <v-icon left>
                    mdi-close
                  </v-icon>
                  <template v-if="$store.getters.languageGetter === '1'">
                    يزيل
                  </template>
                  <template v-else>
                    Remove
                  </template>
                </v-btn>
              </v-col>
              <v-col>
                <div
                  class="mb-2 line-break line-height-sm black--text"
                >
                  {{ $store.getters.languageGetter === '1' ? item.goodName : item.goodNameEn }}
                </div>
                <div class="grey--text">
                  {{ item.goodNo }}
                </div>
                <div class="grey--text">
                  {{ $store.getters.languageGetter === '1' ? item.goodDetailName : item.goodDetailNameEn }}
                </div>
                <div class="mt-2 d-flex align-center justify-space-between">
                  <div class="font-medium black--text d-flex align-center justify-center">
                    <span
                      class="text-h4 me-2"
                    >{{ $store.getters.countryGetter.currency }}{{ (priceRate(item) * $store.getters.rebateGetter / 100).toFixed(2) }}</span>
                    <span :class="$store.getters.rebateGetter < 100 ? 'text-decoration-line-through grey--text' : 'd-none'">{{ $store.getters.countryGetter.currency }}{{ priceRate(item).toFixed(2) }}</span>
                  </div>
                  <stepper
                    :value="+item.goodNumber"
                    :disabled="+item.goodNumber <= +item.moq"
                    large
                    @update:value="editCart(item,$event)"
                    @update:minus="editCart(item,$event)"
                    @update:plus="editCart(item,$event)"
                  />
                </div>
              </v-col>
            </v-row>
          </v-container>
          <v-divider v-if="i < cartList.data.length - 1" />
        </div>
        <div class="text-h2 font-medium d-flex px-4">
          <template v-if="$store.getters.languageGetter === '1'">
            مجموع:
          </template>
          <template v-else>
            Total:
          </template>
          <div class="ms-auto">
            {{ $store.getters.countryGetter.currency }}{{ totalAmount }}
          </div>
        </div>
        <v-divider />
        <div class="px-4">
          <v-btn
            color="#f51414"
            block
            x-large
            depressed
            dark
            class="my-4 font-medium text-uppercase"
            @click="placeOrder"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              الدفع
            </template>
            <template v-else>
              Check Out
            </template>
          </v-btn>
        </div>
      </v-card>
      <v-card
        v-else
        elevation="0"
        tile
        outlined
      >
        <v-container
          class="py-0"
        >
          <v-row>
            <v-col cols="9">
              <v-data-table
                v-model="selected"
                :headers="headers"
                :items="cartList.data"
                item-key="goodDetailId"
                class="data-table-with-select"
                no-data-text="Nothing here"
                loading-text="Loading..."
                show-select
                hide-default-footer
                disable-pagination
              >
                <template v-slot:item.item="{item}">
                  <div
                    class="py-3 d-flex"
                  >
                    <div>
                      <router-link :to="{name: 'GoodsDetail', params: {id: item.goodId}}">
                        <v-img
                          :src="item.image + '?x-oss-process=image/resize,m_mfit,w_375,h_375'"
                          aspect-ratio="1"
                          contain
                          width="80"
                          height="80"
                          class="grey lighten-5"
                        >
                          <template v-slot:placeholder>
                            <v-row
                              class="fill-height ma-0"
                              align="center"
                              justify="center"
                            >
                              <v-progress-circular
                                indeterminate
                                color="grey"
                              />
                            </v-row>
                          </template>
                        </v-img>
                      </router-link>
                    </div>
                    <div
                      class="ps-3"
                      style="max-width:300px"
                    >
                      <div class="mb-2 line-break line-height-sm black--text">
                        {{ $store.getters.languageGetter === '1' ? item.goodName : item.goodNameEn }}
                      </div>
                      <div class="grey--text">
                        {{ item.goodNo }}
                      </div>
                      <div class="grey--text">
                        {{ $store.getters.languageGetter === '1' ? item.goodDetailName : item.goodDetailNameEn }}
                      </div>
                    </div>
                  </div>
                </template>
                <template v-slot:item.goodNumber="{item}">
                  <div class="d-flex justify-center">
                    <stepper
                      :value="+item.goodNumber"
                      :disabled="+item.buNumber <= +item.moq"
                      @update:value="editCart(item,$event)"
                      @update:minus="editCart(item,$event)"
                      @update:plus="editCart(item,$event)"
                    />
                  </div>
                </template>
                <template v-slot:item.price="{item}">
                  <div class="d-flex align-center justify-center">
                    <span
                      class="me-2"
                    >{{ $store.getters.countryGetter.currency }}{{ (priceRate(item) * $store.getters.rebateGetter / 100).toFixed(2) }}</span>
                    <span :class="$store.getters.rebateGetter < 100 ? 'text-decoration-line-through grey--text' : 'd-none'">{{ $store.getters.countryGetter.currency }}{{ priceRate(item).toFixed(2) }}</span>
                  </div>
                </template>
                <template v-slot:item.summary="{item}">
                  {{ $store.getters.countryGetter.currency }}{{ +(priceRate(item) * $store.getters.rebateGetter / 100 * +item.goodNumber).toFixed(2) }}
                </template>
                <template v-slot:item.action="{item}">
                  <v-btn
                    icon
                    x-small
                    @click="dialogDelete = true;toDelete = item.goodDetailId"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </template>
              </v-data-table>
            </v-col>
            <v-divider
              vertical
              style="margin-right:-1px"
            />
            <v-col
              cols="3"
              class="px-6"
            >
              <div class="pb-2 py-1 text-h4 font-medium">
                <template v-if="$store.getters.languageGetter === '1'">
                  ملخص الطلب
                </template>
                <template v-else>
                  Order Summary
                </template>
              </div>
              <v-divider />
              <div class="d-flex justify-space-between align-baseline">
                <span class="grey--text"><template v-if="$store.getters.languageGetter === '1'">
                                           مجموع:
                                         </template>
                  <template v-else>
                    Total:
                  </template> </span>
                <span class="font-medium text-h4">{{ $store.getters.countryGetter.currency }}{{ totalAmount }}</span>
              </div>
              <v-btn
                color="#f51414"
                block
                large
                depressed
                dark
                class="mt-6 mb-2 font-medium"
                @click="placeOrder"
              >
                <template v-if="$store.getters.languageGetter === '1'">
                  الدفع
                </template>
                <template v-else>
                  Check Out
                </template>
              </v-btn>
              <div class="text-center text-h5">
                <router-link
                  to="/"
                  class="text-decoration-underline"
                >
                  <template v-if="$store.getters.languageGetter === '1'">
                    مواصلة التسوق
                  </template>
                  <template v-else>
                    Continue Shopping
                  </template>
                </router-link>
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card>
    </v-container>
    <v-container v-else>
      <v-card
        outlined
        tile
        elevation="0"
        class="pa-8 text-center"
      >
        <div class="my-8">
          <v-icon
            size="128"
            color="grey lighten-1"
          >
            mdi-cart-outline
          </v-icon>
        </div>
        <div class="mt-4 text-h2 font-medium">
          <template v-if="$store.getters.languageGetter === '1'">
            سلة التسوق الخاصة بك فارغة.
          </template>
          <template v-else>
            Your shopping cart is empty.
          </template>
        </div>
        <div class="my-8">
          <v-btn
            color="#f51414"
            depressed
            dark
            large
            to="/"
            class="text-capitalize text-h5 px-8"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              مواصلة التسوق
            </template>
            <template v-else>
              Continue shopping
            </template>
          </v-btn>
        </div>
      </v-card>
    </v-container>
    <v-container
      class="pb-8"
      :class="$store.state.mobile ? 'px-0' : ''"
    >
      <TabGoods
        outlined
        :tabs="[0,1,2]"
      />
    </v-container>
    <v-dialog
      v-model="dialogDelete"
      max-width="400"
    >
      <v-card>
        <v-card-title class="pe-2">
          <v-spacer />
          <v-btn
            icon
            @click="dialogDelete = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-4 px-4 headline black--text d-flex align-center">
          <v-icon
            size="48"
            color="#f1c054"
            class="me-2"
          >
            mdi-information
          </v-icon>
          <template v-if="$store.getters.languageGetter === '1'">
            لا يمكن استرجاعه بعد الحذف ، هل تريد الاستمرار؟
          </template>
          <template v-else>
            Irretrievable after deletion, continue?
          </template>
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            color="grey darken-1"
            text
            outlined
            @click="dialogDelete = false"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              يلغي
            </template>
            <template v-else>
              Cancel
            </template>
          </v-btn>
          <v-btn
            :loading="deletting"
            color="#ff9a00"
            depressed
            dark
            @click="deleteCart"
          >
            <template v-if="$store.getters.languageGetter === '1'">
              يتأكد
            </template>
            <template v-else>
              Confirm
            </template>
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="show"
      max-width="400"
    >
      <v-card>
        <v-card-title class="pe-2">
          <v-spacer />
          <v-btn
            icon
            @click="show = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="pb-8 px-4 headline black--text d-flex align-center">
          <v-icon
            size="48"
            color="#f1c054"
            class="me-2"
          >
            mdi-information
          </v-icon>
          {{ info }}
        </v-card-text>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';
import Stepper from '@/components/Stepper.vue';
import TabGoods from '@/components/TabGoods.vue';

export default {
  name: 'CartList',
  components: {
    Stepper,
    TabGoods,
  },
  data() {
    return {
      loading: false,
      dialogDelete: false,
      show: false,
      info: '',
      deletting: false,
      selected: [],
      toDelete: '',
    };
  },
  computed: {
    ...mapState('cart', ['cartList']),
    headers() {
      return [
        {
          text: this.$store.getters.languageGetter === '1' ? 'بند' : 'Item',
          align: 'start',
          sortable: false,
          value: 'item',
          class: 'text-h6 black--text',
        },
        {
          align: 'center',
          text: this.$store.getters.languageGetter === '1' ? 'سعر' : 'Price',
          value: 'price',
          sortable: true,
          class: 'text-h6 black--text',
        },
        {
          align: 'center',
          text: this.$store.getters.languageGetter === '1' ? 'كمية' : 'Quantity',
          value: 'goodNumber',
          class: 'text-h6 black--text',
          sortable: true,
        },
        {
          align: 'center',
          text: this.$store.getters.languageGetter === '1' ? 'ملخص الطلب' : 'Order Summary',
          value: 'summary',
          class: 'text-h6 black--text',
          sortable: false,
        },
        {
          align: 'right',
          text: '',
          value: 'action',
          sortable: false,
        },
      ];
    },
    totalAmount() {
      return this.selected.reduce((acc, item) => acc + +this.priceRate(item) * +item.buNumber * (this.$store.getters.rebateGetter / 100), 0).toFixed(2);
    },
    selectedIds() {
      return this.selected.map((item) => item.goodDetailId);
    },
  },
  created() {
    this.loading = true;
    this.getCartListAsync().then(() => {
      if (this.$route.query.selected) {
        this.selected = this.cartList.data.filter((item) => this.$route.query.selected.includes(item.goodDetailId));
      } else {
        this.selected = this.cartList.data;
      }
    }).finally(() => {
      this.loading = false;
    });
  },
  methods: {
    ...mapActions('cart', ['getCartListAsync', 'editCartAsync', 'deleteCartAsync']),
    editCart(item, number) {
      if (number < item.moq) {
        this.$store.commit('TOGGLE_SNACKBAR', {
          type: 'error',
          text: this.$store.getters.languageGetter === '1' ? 'رقم الشراء الخاص بك لا يلبي متطلبات موك' : 'Your purchase number doesn\'t meet the moq requirement',
        });
        return;
      }
      this.$store.commit('SET_MINI_LOADING');
      const params = {
        goodDetailId: item.goodDetailId,
        buUnitId: item.unitId,
        packeNum: '1',
        buNumber: number,
      };
      this.editCartAsync(params).then(() => {
        this.selected = this.cartList.data.filter((subitem) => this.selectedIds.find((id) => id === subitem.goodDetailId));
      }).finally(() => {
        this.$store.commit('SET_MINI_LOADING');
      });
    },
    deleteCart() {
      this.deletting = true;
      this.deleteCartAsync({ goodDetailIds: [this.toDelete] }).then(() => {
        this.dialogDelete = false;
        const arr = this.selected;
        const index = this.selected.findIndex((item) => item.goodDetailId === this.toDelete);
        arr.splice(index, 1);
        this.selected = arr;
      }).finally(() => {
        this.deletting = false;
      });
    },
    placeOrder() {
      if (!this.selected.length) {
        this.info = this.$store.getters.languageGetter === '1' ? 'الرجاء تحديد على الأقل في البند' : 'Please select at least on item';
        this.show = true;
        return;
      }
      this.$router.push({
        name: 'PlaceOrder',
        params: {
          goods: JSON.stringify(this.selected.map((item) => {
            item.price = (this.priceRate(item) * (this.$store.getters.rebateGetter / 100)).toFixed(2);
            return item;
          })),
        },
      });
    },
    priceRate(item) {
      return (+item.countryPrice[this.$store.getters.countryGetter.id] * +this.$store.getters.countryGetter.rate);
    },
  },
  beforeRouteEnter(to, from, next) {
    // 在渲染该组件的对应路由被 confirm 前调用
    // 不！能！获取组件实例 `this`
    // 因为当守卫执行前，组件实例还没被创建
    next((vm) => {
      if (!vm.$store.getters.countryGetter) {
        vm.$store.commit('TOGGLE_SNACKBAR', {
          type: 'error',
          text: vm.$store.getters.languageGetter === '1' ? 'الرجاء تحديد بلد أولا' : 'Please select a country first',
        });
        vm.$router.back();
      }
      return true;
    });
  },
};
</script>

<style lang="scss" scoped>

</style>
